var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Binance Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F3BA2F"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 112,
    width: 32,
    height: 32,
    transform: "rotate(45 128 128)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 56,
    width: 32,
    height: 32,
    transform: "rotate(45 128 72)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 168,
    width: 32,
    height: 32,
    transform: "rotate(45 128 184)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 112,
    width: 32,
    height: 32,
    transform: "rotate(45 72 128)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 112,
    width: 32,
    height: 32,
    transform: "rotate(45 184 128)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.10e108ba04d048854115a227c81122dd.svg";
export { ForwardRef as ReactComponent };